<mat-card class="nps-score-card">
  <mat-card-header class="nps-score-card-header" [ngStyle]="{ 'padding-bottom': paddingBottom }">
    @if (redirectToContact) {
      <mat-card-title class="nps-score-card-title"
        ><a [routerLink]="[routeToContactProfile]">{{ review.Name }}</a></mat-card-title
      >
    } @else {
      <mat-card-title class="ml-nps-score-card-title">{{ review.Name }}</mat-card-title>
    }
    <mat-card-subtitle class="nps-score-time-wrapper">
      <ng-content select="reviews-nps-provider"></ng-content>
      <ng-content select="reviews-nps-address"></ng-content>
      <div class="nps-score-badge-left-time">
        <glxy-badge [color]="npsScoreBadgeColor">
          {{ review.score ?? 0 }}
        </glxy-badge>
        <div class="nps-score-left-time">{{ scoreLeftTime }}</div>
      </div>
    </mat-card-subtitle>
  </mat-card-header>
  <ng-container *ngIf="review.comment">
    <mat-card-content class="nps-review-content">{{ review.comment }}</mat-card-content>
  </ng-container>
  <ng-container *ngIf="review.Email || review.PhoneNumber">
    <mat-card-actions class="nps-card-contact-info">
      <ng-container *ngIf="review.Email">
        <a [href]="'mailto:' + review.Email">{{ review.Email }}</a>
      </ng-container>
      <ng-container *ngIf="formattedPhoneNumber">
        <a [href]="'tel:' + review.PhoneNumber">{{ formattedPhoneNumber }}</a>
      </ng-container>
    </mat-card-actions>
  </ng-container>
  @if (enableResendNPSRequest && resentScoreLeftTime && isDetractor) {
    <mat-card-actions class="resent-date">
      {{ 'NPS_CARD.RESENT_REQUEST' | translate: { resentDate: resentScoreLeftTime } }}
    </mat-card-actions>
  }
  @if (
    enableResendNPSRequest &&
    isDetractor &&
    !resentScoreLeftTime &&
    !parentNPSId &&
    (review.Email || review.PhoneNumber)
  ) {
    <mat-card-actions class="resend-nps">
      <div class="resend-text">
        {{ 'NPS_CARD.RESEND_REQUEST' | translate }}
      </div>
      <button
        mat-stroked-button
        class="resend-button"
        (click)="resendNPSRequest(review.netPromoterScoreId, review.Email)"
      >
        {{ 'NPS_CARD.RESEND_NPS_REQUEST' | translate }}
      </button>
    </mat-card-actions>
  }
</mat-card>
